// extracted by mini-css-extract-plugin
module.exports = {"shirt":"CategoryIcon_shirt__v5lIg"};